import propOr from 'ramda/src/propOr'
import prop from 'ramda/src/prop'
import pathOr from 'ramda/src/pathOr'
import propEq from 'ramda/src/propEq'
import find from 'ramda/src/find'
import compose from 'ramda/src/compose'
import map from 'ramda/src/map'
import addIndex from 'ramda/src/addIndex'
import equals from 'ramda/src/equals'
import memoizeWith from 'ramda/src/memoizeWith'
import currentRouteModuleTypes from 'root/src/client/logic/route/selectors/currentRouteModuleTypes'

import {
	formModuleLenses, formStoreLenses,
} from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import stepFormCurrentPage from 'root/src/client/logic/form/selectors/stepFormCurrentPage'

const { pathOrPostFormSubmits } = formModuleLenses
const { viewFormSubmitting } = formStoreLenses

// TODO make common interface with formSubmits

export default memoizeWith(
	(state, { moduleKey }) => moduleKey + JSON.stringify(pathOr([], ['form', moduleKey, 'stepIdHistory'], state)),
	(state, props) => {
		const { moduleId, moduleKey } = props
		const currentRouteModuleType = prop(
			1, find(propEq(0, moduleId), currentRouteModuleTypes(state)),
		)
		return compose(
			addIndex(map)(({ label, buttonType, customSubmitType, icon, componentProps }, submitIndex) => [
				label,
				submitIndex,
				equals(
					viewFormSubmitting(props.moduleKey, state),
					submitIndex,
				),
				buttonType,
				customSubmitType,
				icon,
				componentProps,
			]),
		)(
			currentRouteModuleType === 'stepForm'
				? propOr([], 'postFormSubmits', stepFormCurrentPage(state, { moduleKey, moduleId }))
				: pathOrPostFormSubmits(moduleId, [], moduleDescriptions),
		)
	},
)
